// extracted by mini-css-extract-plugin
export default {"contentBodyContainer":"ContentBody_contentBodyContainer__RexB5"};